import { Injectable } from '@angular/core';
import { SocieteCaracteristique, SocieteCaracteristiqueToHandle } from '@get/api-interfaces';
import { SocieteCaracteristiqueActions, SocieteCaracteristiqueGeneratedActions } from '@get/store/actions';
import { SocieteCaracteristiqueApiService } from '@get/store/api-services';
import { AppState } from '@get/store/configs/reducers';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, concatMap, map, switchMap } from 'rxjs/operators';
import { GeneratedSocieteCaracteristiqueEffects } from './societe-caracteristique-generated.effects';

@Injectable()
export class SocieteCaracteristiqueEffects extends GeneratedSocieteCaracteristiqueEffects {
  constructor(
    actions$: Actions,
    societeCaracteristiqueApiService: SocieteCaracteristiqueApiService,
    store$: Store<AppState>
  ) {
    super(actions$, societeCaracteristiqueApiService, store$);
  }

  handleManySocieteCaracteristiques$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(SocieteCaracteristiqueActions.handleManySocieteCaracteristiques),
      concatMap((params: SocieteCaracteristiqueToHandle) => {
        return this.societeCaracteristiqueApiService.handleManySocieteCaracteristiques(params).pipe(
          map((societeCaracteristiqueReturned: SocieteCaracteristique[]) => {
            return SocieteCaracteristiqueGeneratedActions.normalizeManySocieteCaracteristiquesAfterUpsert({
              societeCaracteristiques: societeCaracteristiqueReturned
            });
          }),
          catchError(error => of(SocieteCaracteristiqueGeneratedActions.societeCaracteristiquesFailure({ error })))
        );
      })
    );
  });
}
